module.exports = __webpack_public_path__ + "500.jpg";